'use client';
// import Header from'@/components/common/Header';
 import HeroSection from'./HeroSection';
 import EventsSection from'./EventsSection';
 import UpcomingEventsSection from'./UpcomingEventsSection';
 import AboutSection from'./AboutSection';
 import CommunitySection from'./CommunitySection';
 import PartnersSection from'./PartnersSection';
 import SubscribeSection from'./SubscribeSection';
 import FooterSection from'./FooterSection';
 import MediaPartnersSection from'./MediaPartnersSection';
 import SpeakerSection from'./SpeakerSection';
import GallerySection from './GallerySection';
import NewSpeakersSection from './NewSpeakersSection';




const HomePage = () => {
  return (
    <div data-component-id="src/app/HomePage.tsx:21:4" data-component-path="src/app/HomePage.tsx" data-component-line="21" data-component-file="HomePage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20bg-secondary-light%22%7D" className="w-full bg-secondary-light">
      <div data-component-id="src/app/HomePage.tsx:22:6" data-component-path="src/app/HomePage.tsx" data-component-line="22" data-component-file="HomePage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20justify-start%20items-center%20w-full%22%7D" className="flex flex-col justify-start items-center w-full">
        {/* Header */}
        {/* <Header /> */}
        
        {/* Main Content */}
        <main data-component-id="src/app/HomePage.tsx:27:8" data-component-path="src/app/HomePage.tsx" data-component-line="27" data-component-file="HomePage.tsx" data-component-name="main" data-component-content="%7B%22elementName%22%3A%22main%22%2C%22className%22%3A%22w-full%22%7D" className="w-full">
          {/* Hero Section */}
          <HeroSection data-component-id="src/app/HomePage.tsx:29:10" data-component-path="src/app/HomePage.tsx" data-component-line="29" data-component-file="HomePage.tsx" data-component-name="HeroSection" data-component-content="%7B%22elementName%22%3A%22HeroSection%22%7D" />
          
          {/* Upcoming Events Section */}
          <UpcomingEventsSection data-component-id="src/app/HomePage.tsx:32:10" data-component-path="src/app/HomePage.tsx" data-component-line="32" data-component-file="HomePage.tsx" data-component-name="UpcomingEventsSection" data-component-content="%7B%22elementName%22%3A%22UpcomingEventsSection%22%7D" />

          {/* New speakers section */}
          {/* <NewSpeakersSection /> */}

          {/* Events Section */}
          <EventsSection data-component-id="src/app/HomePage.tsx:38:10" data-component-path="src/app/HomePage.tsx" data-component-line="38" data-component-file="HomePage.tsx" data-component-name="EventsSection" data-component-content="%7B%22elementName%22%3A%22EventsSection%22%7D" />

          {/* speaker section */}
          <SpeakerSection data-component-id="src/app/HomePage.tsx:41:10" data-component-path="src/app/HomePage.tsx" data-component-line="41" data-component-file="HomePage.tsx" data-component-name="SpeakerSection" data-component-content="%7B%22elementName%22%3A%22SpeakerSection%22%7D" />

          {/* event highlights */}
          <GallerySection data-component-id="src/app/HomePage.tsx:44:10" data-component-path="src/app/HomePage.tsx" data-component-line="44" data-component-file="HomePage.tsx" data-component-name="GallerySection" data-component-content="%7B%22elementName%22%3A%22GallerySection%22%7D" />

          
          {/* About Section */}
          <AboutSection data-component-id="src/app/HomePage.tsx:48:10" data-component-path="src/app/HomePage.tsx" data-component-line="48" data-component-file="HomePage.tsx" data-component-name="AboutSection" data-component-content="%7B%22elementName%22%3A%22AboutSection%22%7D" />
          
          {/* Community Section */}
          <CommunitySection data-component-id="src/app/HomePage.tsx:51:10" data-component-path="src/app/HomePage.tsx" data-component-line="51" data-component-file="HomePage.tsx" data-component-name="CommunitySection" data-component-content="%7B%22elementName%22%3A%22CommunitySection%22%7D" />
          
          {/* Partners Section */}
          <PartnersSection data-component-id="src/app/HomePage.tsx:54:10" data-component-path="src/app/HomePage.tsx" data-component-line="54" data-component-file="HomePage.tsx" data-component-name="PartnersSection" data-component-content="%7B%22elementName%22%3A%22PartnersSection%22%7D" />

          <MediaPartnersSection data-component-id="src/app/HomePage.tsx:56:10" data-component-path="src/app/HomePage.tsx" data-component-line="56" data-component-file="HomePage.tsx" data-component-name="MediaPartnersSection" data-component-content="%7B%22elementName%22%3A%22MediaPartnersSection%22%7D" />
          
          {/* Subscribe Section */}
          <SubscribeSection data-component-id="src/app/HomePage.tsx:59:10" data-component-path="src/app/HomePage.tsx" data-component-line="59" data-component-file="HomePage.tsx" data-component-name="SubscribeSection" data-component-content="%7B%22elementName%22%3A%22SubscribeSection%22%7D" />
        </main>
        
        {/* Footer */}
        <FooterSection data-component-id="src/app/HomePage.tsx:63:8" data-component-path="src/app/HomePage.tsx" data-component-line="63" data-component-file="HomePage.tsx" data-component-name="FooterSection" data-component-content="%7B%22elementName%22%3A%22FooterSection%22%7D" />
      </div>
    </div>
  )
}

export default HomePage